import { datatypes, inputTypes, objType, selectOptionsKeyName } from "data/globalData";

export const studioAttrGroupLinkedTables = {
	// sync with backend data
	shoot: { name: "Shoot", key: "shoot", sqlTable: "shoot", seqMethod: "ShootModal" },
	shoot_details: { name: "Shoot Details", key: "shoot_details", sqlTable: "shoot_details", seqMethod: "ShootDetailsModal" },
	modal_profile: { name: "Model Profile", key: "modal_profile", sqlTable: "modal_profile", seqMethod: "ModalProfileModal" },
	modal_profile_details: {
		name: "Model Profile Details",
		key: "modal_profile_details",
		sqlTable: "modal_profile_details",
		seqMethod: "ModalProfileDetailsModal",
	},
};

export const studioAttrGrpTableStrColumnsObj = {
	group_id: {
		name: "Group Id",
		key: "group_id",
		input_type: inputTypes.AUTO_GENERATE.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: true },
		data: {},
		data_type: datatypes.NUMBER.key,
		sort_no: 1,
	},
	name: {
		name: "Name",
		key: "name",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: true },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 0,
	},
	linked_table: {
		name: "Linked Table",
		key: "linked_table",
		input_type: inputTypes.SELECT.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 2,
		[selectOptionsKeyName]: { type: objType, list: studioAttrGroupLinkedTables },
		value_getter: (feild, row) => {
			return studioAttrGroupLinkedTables[row[feild]]?.name;
		},
	},
	sort_no: {
		name: "Sort No",
		key: "sort_no",
		input_type: inputTypes.ENTER.key,
		sort_no: 4,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data_type: datatypes.NUMBER.key,
		data: {},
	},
	collection_type: {
		name: "Collection Type",
		key: "collection_type",
		input_type: inputTypes.AUTO_GENERATE.key,
		sort_no: 5,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data_type: datatypes.STRING.key,
		data: {},
	},
	is_main: {
		name: "Is main",
		key: "is_main",
		input_type: inputTypes.AUTO_GENERATE.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: true },
		data: {},
		data_type: datatypes.BOOLEAN.key,
		sort_no: 1,
	},
};
